<template>
  <div
    class="relative inline-block text-left"
    v-click-outside="closeMenu"
    v-esc="closeMenu"
  >
    <div>
      <button
        type="button"
        class="tw-simple-button items-center"
        aria-expanded="true"
        aria-haspopup="true"
        @click.prevent="toggleMenu"
      >
        {{ buttonLabel }}
        <svg class="w-4 h-4 ml-2 -mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </button>
    </div>

    <transition
      enter-active-class="transition duration-100 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-show="menuOpen"
        class="absolute right-0 w-56 py-1 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5"
        role="menu"
        aria-orientation="vertical"
        aria-hidden="true"
      >
        <div class="py-1">
          <slot name="options" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
    directives: {
      ClickOutside,
    },
    props: {
        buttonLabel: {
            type: String,
            required: true,
        },
    },
    data: () => ({
      menuOpen: false,
    }),
    methods: {
      toggleMenu() {
        this.menuOpen = !this.menuOpen;
      },
      closeMenu() {
        if(this.menuOpen) {
          this.menuOpen = false;
        }
      },
    }
};

</script>
